module.exports = __webpack_public_path__ + "img/a-z-active.c8e9d6ca.svg";